import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {StringRendererComponent} from '@workflow/renderer/string-renderer/string-renderer.component';
import {FormRenderConfig} from '../form-schema-renderer.component';

function applyTo<T, R>(value: T): (fn: (value: T) => R) => R {
	return fn => fn(value);
}

@Component({
	selector: 'app-card-style-string-renderer',
	templateUrl: './card-style-renderer-type-string.component.html',
	styleUrls: ['./card-style-renderer-type-string.component.scss']
})
export class CardStyleRendererStringTypeComponent extends StringRendererComponent implements OnInit, OnChanges {	
	@Input() formConfig: FormRenderConfig;
	@Input() schemaKey: string;
	@Input() required: boolean;
	@Output() valid: EventEmitter<boolean> = new EventEmitter();

	private validators: ((value: string | Date) => boolean)[];
	
	constructor() {
		super();
	}

	ngOnInit(): void {
		this.valid.emit(!this.required);
	}

	get key(): string {
		return this.property.join('.');
	}
	
	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);
		
		this.validators = Array.from(this.collectValidators());
	}
	
	private* collectValidators(): Generator<(value: (string | Date)) => boolean, void, void> {
		if (this.required){
			yield (value: string | Date) => Boolean(value);
		}
		
		if (this.schema?.minLength){
			yield (value: string | Date) => typeof value === 'string' && value.length > this.schema.minLength;
		}
		
		if (this.schema?.maxLength){
			yield (value: string | Date) => typeof value === 'string' && value.length < this.schema.maxLength;
		}
		
		if (this.schema?.pattern){
			const pattern = RegExp(this.schema.pattern);
			yield (value: string | Date) => typeof value === 'string' && pattern.test(value);
		}
	}
	
	setValid(input: string | Date): void {
		this.valid.emit(this.validators.every(applyTo(input)));
	}
}
